const FALLBACK_SITE_ORIGIN = 'https://guhso.com';

export const SITE_NAME = 'GUHSO';
export const DEFAULT_META_TITLE = 'Guhso | Yardie A Farin, Bare Vibez';
export const DEFAULT_META_DESCRIPTION = 'GUHSO podcast, culture, tech, and stories.';
export const DEFAULT_META_IMAGE = `${FALLBACK_SITE_ORIGIN}/images/thumbnails/hero-featured.jpg`;

export function getSiteOrigin() {
  const configuredOrigin = process.env.REACT_APP_SITE_URL;

  if (configuredOrigin) {
    return configuredOrigin.replace(/\/+$/, '');
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin.replace(/\/+$/, '');
  }

  return FALLBACK_SITE_ORIGIN;
}

export function buildCanonicalUrl(pathname = '/') {
  const normalizedPath = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${getSiteOrigin()}${normalizedPath}`;
}

export function getDefaultMetaForPath(pathname = '/') {
  const routes = [
    {
      match: pathname === '/',
      title: DEFAULT_META_TITLE,
      description: 'Listen to the GUHSO podcast, explore blog stories, and catch curated tech and culture updates.',
      type: 'website',
    },
    {
      match: pathname === '/episodes',
      title: 'Episodes',
      description: 'Browse every GUHSO episode, from new releases to archived conversations and subscriber exclusives.',
      type: 'website',
    },
    {
      match: pathname.startsWith('/episode/'),
      title: 'Episode',
      description: 'Listen to this GUHSO episode and share it with a rich preview card.',
      type: 'article',
    },
    {
      match: pathname === '/blog',
      title: 'It Guhso',
      description: 'Read GUHSO blog posts on culture, commentary, and community stories.',
      type: 'website',
    },
    {
      match: pathname.startsWith('/blog/'),
      title: 'Blog Article',
      description: 'Read this GUHSO article and share it with a rich preview card.',
      type: 'article',
    },
    {
      match: pathname === '/tech',
      title: 'Tech Insights',
      description: 'Explore GUHSO tech coverage on digital trends, tools, and innovation.',
      type: 'website',
    },
    {
      match: pathname.startsWith('/tech/'),
      title: 'Tech Article',
      description: 'Read this GUHSO tech article and share it with a rich preview card.',
      type: 'article',
    },
    {
      match: pathname === '/about',
      title: 'About',
      description: 'Learn the story behind GUHSO, the team, the culture, and the platform.',
      type: 'website',
    },
    {
      match: pathname === '/donation',
      title: 'Support GUHSO',
      description: 'Support GUHSO with a donation and help fund new episodes, stories, and community content.',
      type: 'website',
    },
    {
      match: pathname === '/merch',
      title: 'Guhso Merch Store',
      description: 'Shop official GUHSO merchandise and support the platform.',
      type: 'website',
    },
    {
      match: pathname.startsWith('/merch/'),
      title: 'Product',
      description: 'View this GUHSO merch product and share it with a rich preview card.',
      type: 'product',
    },
    {
      match: pathname === '/cart',
      title: 'Cart',
      description: 'Review your GUHSO cart before checkout.',
      type: 'website',
    },
    {
      match: pathname === '/advertise',
      title: 'Advertise with Guhso',
      description: 'See placements, pricing, and sponsorship options across Guhso\'s site and directory.',
      type: 'website',
    },
    {
      match: pathname === '/directory',
      title: 'Directory',
      description: 'Browse GUHSO partners, sponsors, and featured directory listings.',
      type: 'website',
    },
    {
      match: pathname === '/signin',
      title: 'Sign In',
      description: 'Sign in to your GUHSO account.',
      type: 'website',
    },
    {
      match: pathname === '/register',
      title: 'Register',
      description: 'Create your GUHSO account.',
      type: 'website',
    },
    {
      match: pathname === '/membership/checkout',
      title: 'Membership Checkout',
      description: 'Start or manage your GUHSO membership checkout.',
      type: 'website',
    },
    {
      match: pathname === '/signout',
      title: 'Sign Out',
      description: 'Sign out of your GUHSO account.',
      type: 'website',
    },
    {
      match: pathname === '/profile',
      title: 'Profile',
      description: 'Manage your GUHSO profile and subscription details.',
      type: 'website',
    },
    {
      match: pathname === '/checkout',
      title: 'Checkout',
      description: 'Complete your GUHSO order.',
      type: 'website',
    },
    {
      match: pathname === '/advertise/checkout',
      title: 'Book a Directory placement',
      description: 'Choose an advertising package, pick your dates, and book a Guhso Directory campaign.',
      type: 'website',
    },
    {
      match: pathname === '/privacy',
      title: 'Privacy Policy',
      description: 'What GUHSO collects, why, who else touches it, and how to get it back or get rid of it.',
      type: 'article',
    },
    {
      match: pathname === '/terms',
      title: 'Terms of Service',
      description: 'The agreement covering the GUHSO shop, memberships, donations, and directory advertising.',
      type: 'article',
    },
    {
      match: pathname === '/returns',
      title: 'Returns & Shipping',
      description: 'How GUHSO merchandise is shipped, and how to return or exchange it.',
      type: 'article',
    },
  ];

  const routeMeta = routes.find((route) => route.match);

  return {
    title: routeMeta?.title || DEFAULT_META_TITLE,
    description: routeMeta?.description || DEFAULT_META_DESCRIPTION,
    image: DEFAULT_META_IMAGE,
    siteName: SITE_NAME,
    type: routeMeta?.type || 'website',
    url: buildCanonicalUrl(pathname),
  };
}
